import { render, staticRenderFns } from "./Comissoes.vue?vue&type=template&id=fa97863e&scoped=true"
import script from "./Comissoes.vue?vue&type=script&lang=js"
export * from "./Comissoes.vue?vue&type=script&lang=js"
import style0 from "./Comissoes.vue?vue&type=style&index=0&id=fa97863e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa97863e",
  null
  
)

export default component.exports